<template>
    <div class="notebook__list">
        <b-row>
            <b-col cols="12" md="4" lg="3">
                <b-btn
                    variant="primary"
                    v-if="createButton"
                    class="btn-block"
                    @click="$bus.$emit('note-form-window.open')"
                >
                    <i class="fa fa-plus"></i> Ingresar minuta
                </b-btn>
            </b-col>
        </b-row>
        <div class="filters">
            <app-sub-title text="Filtros" />
            <b-card>
                <div class="card-text">
                    <b-row>
                        <b-col cols="12" md="6" lg="3" v-if="isOperative">
                            <b-button class="btn-block" @click="myTransients()"
                                >Mis consignas transitorias</b-button
                            >
                        </b-col>
                        <b-col cols="12" md="5">
                            <app-autocomplete
                                :items="clients"
                                placeholder="Cliente"
                                :value="client"
                                :disabled="clientFilterDisabled"
                                v-model="selectedClient"
                            ></app-autocomplete>
                        </b-col>
                        <b-col cols="12" md="3">
                            <app-form-select-input
                                placeholder="Tipo de anotación"
                                :options="annotationTypes"
                                v-model="filters.type"
                            ></app-form-select-input>
                        </b-col>

                        <b-col cols="6" md="3">
                            <app-date-time-picker
                                id="from"
                                placeholder="Desde"
                                v-model="filters.from"
                                :with-time="false"
                            ></app-date-time-picker>
                        </b-col>

                        <b-col cols="6" md="3">
                            <app-date-time-picker
                                id="to"
                                placeholder="Hasta"
                                v-model="filters.to"
                                :with-time="false"
                            ></app-date-time-picker>
                        </b-col>

                        <b-col cols="12" md="5">
                            <app-form-select-input
                                placeholder="Autor"
                                :options="authors"
                                v-model="filters.author"
                            ></app-form-select-input>
                        </b-col>
                        <div class="w-100"></div>
                        <b-col cols="12" md="3">
                            <app-form-select-input
                                placeholder="¿Tiene archivos?"
                                :options="files"
                                v-model="filters.file"
                            ></app-form-select-input>
                        </b-col>
                        <b-col cols="12" md="6" lg="3">
                            <app-form-text-input
                                placeholder="Palabra"
                                v-model="filters.term"
                            ></app-form-text-input>
                        </b-col>
                        <b-col cols="12" md="3">
                            <b-checkbox
                                v-model="filters.ofSupervision"
                                value="1"
                                unchecked-value
                                >Solo supervisores</b-checkbox
                            >
                        </b-col>
                        <b-col cols="12" md="3" class="right-spaced">
                            <b-btn
                                @click="onFilter"
                                variant="primary"
                                class="mr-2"
                            >
                                <i class="fa fa-filter"></i>
                            </b-btn>
                            <b-btn @click="cancelFilter" variant="secondary">
                                <i class="fa fa-times-circle"></i>
                            </b-btn>
                        </b-col>
                    </b-row>
                </div>
            </b-card>
        </div>
        <app-table-notebook
            :data="theNotes"
            @change-page="onChangePage"
            @start-finalize="startFinalize"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up title="Confirmación" id="finalize-transitory">
            <div slot="body">
                <h2>
                    ¿Esta seguro que desea marcar esta consigna transitoria como
                    finalizada?
                </h2>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="finalize(selectedNote)">
                    <i class="fa fa-check" aria-hidden="true"></i> Confirmar
                    finalización de consigna transitoria
                </button>
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import notebookRepository from '../../../../repositories/notebook.repository'
import DateTimePicker from '../../../UI/Controls/DateTimePicker/DateTimePicker.vue'
import TableNotebook from './TableNotebook/TableNotebook.vue'

export default {
    components: {
        appDateTimePicker: DateTimePicker,
        appTableNotebook: TableNotebook,
    },

    props: {
        createButton: {
            type: Boolean,
            default: true,
        },
        actionButtons: {
            type: Boolean,
            default: true,
        },
        theClientId: {
            default: '',
        },
        supervisor: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            page: 1,
            selectedNote: null,
            theNotes: {},
            authors: [],
            filters: {
                type: '',
                author: '',
                from: '',
                to: '',
                assigned: '',
                file: '',
                ofSupervision: '',
                term: '',
            },
            files: [
                {
                    id: 1,
                    name: 'Si',
                },
                {
                    id: 0,
                    name: 'No',
                },
            ],
            sort: {
                sortBy: 'notebook.created_at',
                sortDir: 'desc',
            },
            isOperative: false,
            selectedClient: null,
        }
    },
    watch: {
        theClientId(val) {
            if (val) {
                this.loadAuthorsAndNotes()
            }
        },
        selectedClient(val) {
            this.$store.commit('client', val)
            if (!val) return (this.theNotes = {})
            this.loadAuthorsAnnotations()
            this.loadNotes()
        },
    },
    computed: {
        ...mapGetters(['annotationTypes', 'clients']),
        imAuthor(note) {
            return note.user.id === this.user.id
        },
        clientFilterDisabled() {
            return ['vigilante', 'cliente-admin', 'miembro-asociado'].includes(
                this.user.profile.slug
            )
        },
        currentClientId() {
            return !!this.theClientId
                ? this.theClientId
                : !!this.client
                ? this.client.id
                : !!this.selectedClient
                ? this.selectedClient.id
                : null
        },
    },
    methods: {
        // onClientChange(client) {
        //     debugger
        // },
        loadAuthorsAnnotations() {
            if (!this.currentClientId) return
            const nr = Object.assign({}, notebookRepository)
            nr.getAuthorsAnnotations(this.currentClientId)
                .then(data => (this.authors = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los autores de las anotaciones'
                    )
                )
        },
        finalize(note) {
            const nr = Object.assign({}, notebookRepository)
            nr.finalize(this.selectedNote.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.$bus.$emit('finalize-transitory.close')
                        this.loadNotes()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error(
                        'ocurrio un error al finalizar la consigna transitoria'
                    )
                })
        },
        startFinalize(note) {
            this.selectedNote = note
            this.$bus.$emit('finalize-transitory.open')
        },
        onFilter() {
            this.page = 1
            this.loadNotes()
        },
        cancelFilter() {
            this.page = 1
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.$bus.$emit('to.clear')
            this.$bus.$emit('from.clear')
            this.loadNotes()
        },
        async loadNotes() {
            if (!this.currentClientId) return (this.theNotes = {})

            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
                page: this.page,
                clientId: this.currentClientId,
                with: 'user.profile:id,slug',
            }

            if (this.user.profile.slug === 'vigilante')
                filters['venue'] = this.accessPoint.venue_id

            const { data } = await repo.get('notebook', filters)

            const notes = data.data
            const fNotes = notes.map(item => {
                const _rowDetails = true

                const searchMask = this.filters.term
                const regEx = new RegExp(searchMask, 'ig')
                const replaceMask = `<span class="highlighted">${this.filters.term.toUpperCase()}</span>`

                const content = !!this.filters.term
                    ? item.content.replace(regEx, replaceMask)
                    : item.content
                return { ...item, content, _rowDetails }
            })
            const theData = { ...data, data: fNotes }
            this.theNotes = theData
        },
        // carga las notas y los autores
        loadAuthorsAndNotes() {
            this.loadNotes()
            this.loadAuthorsAnnotations()
        },
        onChangePage(page) {
            this.page = page
            this.loadNotes()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadNotes()
        },
        myTransients() {
            this.filters.assigned = !!this.supervisor
                ? this.supervisor.id
                : this.user.id
            this.loadNotes()
        },
    },
    created() {
        this.isOperative = this.user.profile.operative ? true : false
        this.load('annotationTypes')
        this.loadAuthorsAndNotes()
        this.$bus.$on('note-list.refresh', this.loadAuthorsAndNotes)
    },
    mounted() {
        this.load('clients')
    },
}
</script>
